import { render, staticRenderFns } from "./Pastas.vue?vue&type=template&id=acc36df2"
import script from "./Pastas.vue?vue&type=script&lang=js"
export * from "./Pastas.vue?vue&type=script&lang=js"
import style0 from "./Pastas.vue?vue&type=style&index=0&id=acc36df2&prod&lang=stylus"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports